import React, { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import ClubAvatar from '../../../Units/ClubAvatar';
import { changeClubRequest } from '../../../../store/actionCreators/club';
import { getAccountAvatars, getCurrentClub } from '../../../../store/selectors';
import '../../../../assets/stylesheets/Dialogs/ClubEdit.scss';

const EditClub =({ club }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const avatarList = useSelector(getAccountAvatars);
  const [clubName, setClubName] = useState(club.clubName);
  const [clubDescription, setClubDescription] = useState(club.description);
  const [clubAvatar, setClubAvatar] = useState({});//club.avatarURL

  const insertClubName = useCallback((e) => {
    setClubName(e.target.value);
  });
  const insertClubDescription = useCallback((e) => {
    setClubDescription(e.target.value);
  });
  const changeClubImage = (e) => {
    var reader = new FileReader();
    let fileName = e.target.value.split("\\");
    fileName = fileName[fileName.length - 1].split(".")[0];
    if (e.target.files[0]) {
      reader.readAsDataURL(e.target.files[0]);
    }
    reader.onload = function () {
      setTimeout(() => {
        setClubAvatar({name: fileName, data: reader.result});
      }, 500)
    };
    reader.onerror = function (error) {
      console.log('Error: ', error);
    };
  };

  const requestChanges = useCallback(() => {
    dispatch(changeClubRequest({
      clubName,
      clubDescription,
      clubAvatar: clubAvatar.data ? clubAvatar : null
    }));
  });

  return (
    <React.Fragment>
      <button className="shareBtn"></button>
      <div className="editClubDialog">
        <div className="avatarChangeWrapper">
          <ClubAvatar id={club.clubId} withoutRole className="club-avatar--avatar-change" />
          <span className="changeAvatar">{t('change')}</span>
          <input
            className={`uploadAvatar ${!avatarList[club.clubId] || !avatarList[club.clubId].imagePath ? 'noAvatar' : ''}`}
            type="file"
            accept="image/*"
            onChange={changeClubImage}
          />
        </div>
        {clubAvatar.data ? (
          <div className="uploadAvatarPreview" style={{backgroundImage: 'url(' + clubAvatar.data + ')'}} />
        ) : false}
        <div className="field">
          <span className="labelText">{t('clubName')}</span>
          <label>
            <input defaultValue={clubName} disabled={true} onChange={(e) => insertClubName(e)} />
          </label>
        <div className="remark"><span className="remarkIcon" />{t('freeToRenameForTheFirstTime')}</div>
        </div>
        <div className="field">
          <span className="labelText">{t('clubDescriptionAndRules')}</span>
          <label className="description">
            <textarea defaultValue={clubDescription} onChange={(e) => insertClubDescription(e)} />
          </label>
        </div>
        <button className="saveBtn" onClick={() => requestChanges()}>{t('button.save')}</button>
      </div>
    </React.Fragment>
  );
};


export default EditClub;

